import { render, staticRenderFns } from "./TimePickerCustom.vue?vue&type=template&id=79d90117&scoped=true&"
import script from "./TimePickerCustom.vue?vue&type=script&lang=js&"
export * from "./TimePickerCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d90117",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VDialog,VTimePicker})
